import {
  type Action,
  FilterActionTypes,
  type Thunk,
  action,
  thunk,
} from "easy-peasy";

import { PAGE_SIZE } from "../../dependencies/env";
import { Logger } from "../../dependencies/logger";
import { type LogEffect, createLogEffect } from "../../utils/store";
import {
  type ListInitialLoadSnapshot,
  freezeOpenListInitialLoad,
} from "../../utils/store/listPerformance";

const logEffect = (property: keyof FilterActionTypes<PageModel>) =>
  createLogEffect<PageModel>("PAGE", property, false);

const logger = new Logger("RESTAURANT_STORE - PAGE", "LOG");
// logger.enable();

export type PageModel = {
  limit: number;
  limitOnChange: LogEffect<PageModel>;
  setLimit: Action<PageModel, number>;

  /**
   * Infinite scroll. Freezes the open initial-load sample before the limit
   * grows, so a following page is not part of that measurement.
   */
  nextPage: Thunk<PageModel, void, unknown, ListInitialLoadSnapshot>;
  /** Limit increase used by `nextPage` after the sample is frozen. */
  advancePage: Action<PageModel>;
  resetPage: Action<PageModel>;
};

const pageModel: PageModel = {
  limit: PAGE_SIZE,
  limitOnChange: logEffect("limit"),
  setLimit: action((state, payload) => {
    logger.log("setLimit", payload);

    state.limit = payload;
  }),

  nextPage: thunk((actions, _payload, { getStoreState }) => {
    // Freeze before the limit changes. A page size of 10 makes the first
    // doubling and the first nextPage both land on 20, so the limit value
    // cannot tell expansion from a following page.
    freezeOpenListInitialLoad(getStoreState());
    actions.advancePage();
  }),
  advancePage: action((state) => {
    const newLimit = state.limit + PAGE_SIZE;
    logger.log("nextPage", newLimit);

    state.limit = newLimit;
  }),
  resetPage: action((state) => {
    logger.log("resetPage");

    state.limit = PAGE_SIZE;
  }),
};

export default pageModel;
